module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticStyle: {
      "padding-top": ".5rem",
      "text-align": "center"
    }
  }, [_vm._v("\n\t没有搜索到更多数据!!!\n")])
},staticRenderFns: []}


//////////////////
// WEBPACK FOOTER
// ./~/vue-loader/lib/template-compiler?{"id":"data-v-5459b337"}!./~/vue-loader/lib/selector.js?type=template&index=0!./src/myMixin/noDataDialog/noDataDialog.vue
// module id = 159
// module chunks = 18